/* eslint-disable no-underscore-dangle */
import Axios, { isAxiosError } from 'axios'
import { apiLogin } from '~/api/admin-api'
import { keyCloakInstance } from '~/keyCloackInstance'

// @deprecated use `<KeycloakAxiosConnector>` instead
export const registerAxiosInterceptors = () => {
  Axios.interceptors.request.use((config) => {
    if (keyCloakInstance.token) {
      // @ts-ignore
      return { ...config, headers: config.headers.set('Authorization', `Bearer ${keyCloakInstance.token}`) }
    }
    return config
  })
  Axios.interceptors.response.use(
    (response) => response,
    async function (error) {
      const originalRequest = error.config
      if (error.response && error.response.status === 403 && !originalRequest._retry) {
        originalRequest._retry = true
        await apiLogin()
        return Axios(originalRequest)
      }
      return Promise.reject(error)
    }
  )
}

export const getErrorMessage = (error: unknown, fallback: string) => (isAxiosError(error) ? error.message : fallback)
export const getErrorCode = (error: unknown) => (isAxiosError(error) ? error.code : undefined)
